module.exports = __webpack_public_path__ + "img/38.1ce871c5.jpg";